import { useEffect } from 'react';

import IChildHeightChangeEventPayload from '^types/externalEvents/IChildHeightChangeEventPayload';
import ExternalEvent from '^enums/ExternalEvent';

const CHILD_HEIGHT_CHANGE_EVENT_TARGET_ORIGIN = '*';

const useHeightChangeEventObserver = (): void => {
  useEffect(
    (): void | (() => void) => {
      if (window.xprops.isWidgetMode) {
        return;
      }

      // Emit height change event in non-widget environment
      const observer = new ResizeObserver((): void => {
        const payload: IChildHeightChangeEventPayload = {
          msgType: ExternalEvent.ChildHeightChanged,
          height: document.body.clientHeight,
        };

        window.parent.postMessage(payload, CHILD_HEIGHT_CHANGE_EVENT_TARGET_ORIGIN);
      });

      observer.observe(document.body);

      return (): void => observer.disconnect();
    },
    [],
  );
};

export default useHeightChangeEventObserver;
